<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> 选煤厂管理
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">添加</el-button>
                <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">删除</el-button>
            </div>
        </div>
        <el-table :data="depts" row-key="id" border class="table" ref="multipleTable" element-loading-text="玩命加载中..." v-loading="loading" header-cell-class-name="table-header" :default-expand-all="true" :expand-row-keys="expandRowKeys" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" @selection-change="handleSelectionChange" @row-dblclick="dbSelected">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column prop="coalWashCode" label="选煤厂编码"></el-table-column>
            <el-table-column prop="coalWashName" label="选煤厂名称"></el-table-column>
            <el-table-column prop="coalWashAddr" label="选煤厂地址"></el-table-column>
            <el-table-column prop="coalWashPower" label="洗选能力"></el-table-column>
            <el-table-column prop="standardLevel" label="标准化管理规范等级"></el-table-column>
            <el-table-column prop="washProcess" label="洗选工艺"></el-table-column>
            <el-table-column prop="coalWashType" label="洗煤厂类型"></el-table-column>
            <el-table-column prop="isgsqy" label="是否规上企业"></el-table-column>
            <el-table-column prop="productionTime" label="投产时间"></el-table-column>
            <el-table-column prop="workersNum" label="用工人数"></el-table-column>
            <el-table-column prop="mainProduct" label="主要产品"></el-table-column>
            <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
        </div>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog :title="headTitle" :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
        <el-form ref="dept" :model="dept" :rules="rules" label-width="90px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="选煤厂编码" prop="address" label-width="140px">
                        <el-input v-model="dept.coalWashCode"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="选煤厂名称" prop="phone" label-width="140px">
                        <el-input v-model="dept.coalWashName"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="选煤厂地址" prop="address" label-width="140px">
                        <el-input v-model="dept.coalWashAddr"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="洗选能力(万吨/年)" prop="phone" label-width="140px">
                        <el-input v-model="dept.coalWashPower"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="标准化管理规范等级" prop="address" label-width="140px">
                        <el-select v-model="dept.standardLevel" class="size-full">
                            <el-option v-for="item in standardLevelType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="洗选工艺" prop="phone" label-width="140px">
                        <el-select v-model="dept.washProcess" class="size-full">
                            <el-option v-for="item in washProcessType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="洗煤厂类型" prop="address" label-width="140px">
                        <el-select v-model="dept.coalWashType" class="size-full">
                            <el-option v-for="item in coalWashTypeType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="是否规上企业" prop="phone" label-width="140px">
                        <el-select v-model="dept.isgsqy" class="size-full">
                            <el-option v-for="item in isgsqyType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="投产时间" prop="address" label-width="140px">
                        <el-input v-model="dept.productionTime"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="用工人数" prop="phone" label-width="140px">
                        <el-input v-model="dept.workersNum"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="主要产品" prop="address" label-width="140px">
                        <el-select v-model="dept.mainProduct" class="size-full">
                            <el-option v-for="item in mainProductType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveEdit('dept')">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import {
    SortField,
    toTree,
    getchild,
    IdPath
} from '../../utils/helper';
import {
    quillEditor
} from 'vue-quill-editor';
import {
    listToTree
} from '../../utils';
let that;
export default {
    name: 'dept',
    data: function () {
        const checkPass = (rule, value, callback) => {
            if (value !== this.dept.Password) {
                callback(new Error('两次输入密码不一致！'));
            } else {
                callback();
            }
        };
        return {
            expandRowKeys: [],
            headTitle: '',
            isadd: false,
            dept: {},
            editVisible: false,
            depts: [],
            allDepts: [],
            allDeptList: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            deptarr: [],
            query: {
                Field1: '',
                Field2: '',
                PageIndex: 1,
                PageSize: 15
            },
            editorOption: {
                placeholder: '请输入内容！！！'
            },
            rules: {
                code: [{
                        required: true,
                        message: '请输入编号',
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        max: 15,
                        message: '长度在 3 到 15 个字符',
                        trigger: 'blur'
                    }
                ],
                name: [{
                    required: true,
                    message: '请输入名称',
                    trigger: 'blur'
                }],

                ip: [{
                    required: true,
                    message: '请输入ip',
                    trigger: 'blur'
                }]
            },
            standardLevelType: [{
                name: '无',
                value: 0
            }, {
                name: '一级',
                value: 1
            }, {
                name: '二级',
                value: 2
            }, {
                name: '三级',
                value: 3
            }],
            washProcessType: [{
                name: '重介分选',
                value: 0
            }, {
                name: '跳汰分选',
                value: 1
            }, {
                name: '重介+浮选',
                value: 2
            }, {
                name: '跳汰+浮选',
                value: 3
            }, {
                name: '重介+TBS+浮选',
                value: 4
            }, {
                name: '跳汰+TBS+浮选',
                value: 5
            }, {
                name: '重介+螺旋',
                value: 6
            }, {
                name: '跳汰+螺旋',
                value: 7
            }, {
                name: '其他',
                value: 9
            }, {
                name: '重介+螺旋+浮选',
                value: 11
            }, {
                name: '跳汰+螺旋+浮选',
                value: 12
            }, ],
            coalWashTypeType: [{
                name: '矿井型',
                value: 0
            }, {
                name: '社会独立型',
                value: 1
            }, {
                name: '用户型',
                value: 2
            }, {
                name: '群矿型',
                value: 3
            }],
            isgsqyType: [{
                name: '是',
                value: 0
            }, {
                name: '否',
                value: 1
            }],
            mainProductType: [{
                name: '入洗原煤',
                value: 1
            }, {
                name: '大块煤',
                value: 2
            }, {
                name: '中块煤',
                value: 3
            }, {
                name: '小块煤',
                value: 4
            }, {
                name: '沫煤',
                value: 5
            }, {
                name: '中煤',
                value: 6
            }, {
                name: '煤泥',
                value: 7
            }, {
                name: '矸石',
                value: 8
            }, {
                name: '入选原煤',
                value: 9
            }, {
                name: '洗沫精煤',
                value: 10
            }, {
                name: '洗块精煤',
                value: 11
            }, {
                name: '筛混煤',
                value: 12
            }],

        };
    },
    filters: {
        areaFieldList(dept) {
            return dept.province + '-' + dept.city + '-' + dept.area;
        },
        cloudSpace(dept) {
            return dept.useSpace + '/' + dept.cloudSpace;
        },
        usertypeFormat(UserType) {
            var usertypeName = '';
            if (UserType == '1') {
                usertypeName = '启用';
            } else {
                usertypeName = '停用';
            }
            return usertypeName;
        }
    },
    components: {
        quillEditor
    },
    created() {
        this.getData();
    },
    beforeCreate() {
        that = this;
    },
    methods: {
        saveEdit() {
            this.$refs['dept'].validate((valid) => {
                if (valid) {
                    if (this.isadd) {
                        this.$zybhttp
                            .post('WashingProductReport/CoalPreparationPlantAdd', this.dept)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success('添加成功');
                                    this.getData();
                                    this.editVisible = false;
                                    this.dept = {};
                                } else {
                                    this.$notify.error('添加失败');
                                }
                            })
                            .catch((err) => this.$notify.error('网络异常！添加失败'));
                    } else {
                        this.$zybhttp
                            .post('WashingProductReport/CoalPreparationPlantUpdate', this.dept)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success('修改成功');
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error('修改失败');
                                }
                            })
                            .catch((err) => this.$notify.error('网络异常！修改失败'));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getData() {
            this.$zybhttp
                .post('WashingProductReport/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        this.depts = d;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getDeptArr() {
            this.$zybhttp
                .post('WashingProductReport/GetList', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        this.allDepts = listToTree(d);
                        this.allDeptList = d;
                        var userDept = parseInt(JSON.parse(window.localStorage.getItem('ms_userInfo')).deptId);
                        var newdata = getchild(d, [userDept], userDept);
                        d = d.filter((x) => newdata.indexOf(x.id) > -1);
                        d = d.sort(SortField('id', 'asc'));
                        var arr = [];
                        for (var i = 0; i < d.length; i++) {
                            arr.push({
                                id: d[i].id,
                                pid: d[i].parentId,
                                value: d[i].id,
                                label: d[i].name
                            });
                        }
                        this.deptarr = toTree(arr);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        handleEdit(id, row) {
            this.getDeptArr();
            this.dept = JSON.parse(JSON.stringify(row));
            this.dept.id = id;
            this.editVisible = true;
            this.isadd = false;
            this.headTitle = '修改部门信息';
        },
        dbSelected(row) {
            this.getDeptArr();
            this.dept = JSON.parse(JSON.stringify(row));
            this.dept.id = row.id;
            this.editVisible = true;
            this.dept.enabled = this.dept.enabled == '1';
            this.isadd = false;
            this.headTitle = '修改部门信息';
        },
        handleAdd() {
            this.getDeptArr();
            this.dept = {};
            this.isadd = true;
            let date = new Date();
            this.editVisible = true;
            this.headTitle = '新增选煤厂信息';
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].coalWashName + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning('请选择删除的行！');
                return;
            }
            this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                })
                .then(() => {
                    this.$zybhttp
                        .get('WashingProductReport/CoalPreparationPlantDel', {
                            params: {
                                ids: strValue
                            }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(`删除了${str}`);
                                this.getData();
                            } else {
                                this.$notify.error('删除失败');
                            }
                        })
                        .catch((err) => this.$notify.error('网络异常！删除失败'));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style><style>
/* 富文本框高度设置 */
.ql-container {
    min-height: 200px;
    height: 200px;
}
</style>
